import React, { useState } from 'react';

interface FilterControlsProps {
  onStatusFilter: (status: string) => void;
  onSort: (sortBy: string, sortOrder: 'asc' | 'desc') => void;
  onSearch: (searchTerm: string) => void;
  filteredCount: number;
  totalCount: number;
}

const FilterControls: React.FC<FilterControlsProps> = ({
  onStatusFilter,
  onSort,
  onSearch,
  filteredCount,
  totalCount
}) => {
  const [statusFilter, setStatusFilter] = useState('');
  const [sortBy, setSortBy] = useState('timestamp');
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('desc');
  const [searchTerm, setSearchTerm] = useState('');

  const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setStatusFilter(value);
    onStatusFilter(value);
  };

  const handleSortChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setSortBy(value);
    onSort(value, sortOrder);
  };

  const handleSortOrderChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value as 'asc' | 'desc';
    setSortOrder(value);
    onSort(sortBy, value);
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);
    onSearch(value);
  };

  return (
    <div className="filter-controls mb-4">
      <h5>🔍 Filter & Sort</h5>
      <div className="filter-row">
        <input
          type="text"
          placeholder="Search by name or email..."
          value={searchTerm}
          onChange={handleSearchChange}
          className="form-input"
        />
        
        <select 
          value={statusFilter} 
          onChange={handleStatusChange} 
          className="form-select"
        >
          <option value="">All Statuses</option>
          <option value="pending">Pending Only</option>
          <option value="approved">Approved Only</option>
          <option value="rejected">Rejected Only</option>
          <option value="invited">Invited Only</option>
        </select>
        
        <select 
          value={sortBy} 
          onChange={handleSortChange} 
          className="form-select"
        >
          <option value="timestamp">Sort by Date</option>
          <option value="name">Sort by Name</option>
          <option value="email">Sort by Email</option>
          <option value="experienceYears">Sort by Experience</option>
          <option value="status">Sort by Status</option>
        </select>
        
        <select 
          value={sortOrder} 
          onChange={handleSortOrderChange} 
          className="form-select"
        >
          <option value="desc">Newest/Desc</option>
          <option value="asc">Oldest/Asc</option>
        </select>
      </div>
      <div className="filter-info">
        <span>Showing {filteredCount} of {totalCount} signups</span>
      </div>
    </div>
  );
};

export default FilterControls;
